// extracted by mini-css-extract-plugin
export default {"coupon":"Coupon_coupon__sHRjX","bg":"Coupon_bg__oIZtC"};